export default __webpack_public_path__ + "static/media/pic6.a06bd7c3.jpg";